import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=c8841560&scoped=true&"
import script from "./DetailsDialog.vue?vue&type=script&lang=js&"
export * from "./DetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=c8841560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8841560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8841560')) {
      api.createRecord('c8841560', component.options)
    } else {
      api.reload('c8841560', component.options)
    }
    module.hot.accept("./DetailsDialog.vue?vue&type=template&id=c8841560&scoped=true&", function () {
      api.rerender('c8841560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/supplierDialog/DetailsDialog.vue"
export default component.exports